// import formatTime from '@/utils/common.js';
export const tableConfig = {
    searchList: {
        // defaultValue: {
        //     billDate: [formatTime.initStartDate(30), formatTime.initEndDate()]
        // },
        searchTxt: [
            {
                type: 'input',
                value: 'barcodeNo',
                span: 6,
                name: '条码字符串',
                clearable: true
                // name: $translate('lang.E3202101280001', {
                //     defaultText: '条码字符串'
                // })
            },
            {
                type: 'input',
                value: 'wipEntityName',
                span: 6,
                name: '工单号',
                clearable: true
            },
            {
                type: 'input',
                value: 'orderNo',
                span: 6,
                name: '生产订单号',
                clearable: true
            },
            {
                type: 'input',
                value: 'boxingPrefix',
                span: 6,
                name: '箱前缀',
                clearable: true
            },
            {
                type: 'input',
                value: 'mitemLotNo',
                span: 6,
                name: '物料批次号',
                clearable: true
            },
            {
                type: 'input',
                value: 'sourceBillNo',
                span: 6,
                name: '出货通知书',
                clearable: true
            },
            {
                type: 'input',
                value: 'actContainerNo',
                span: 6,
                name: '实际柜号',
                clearable: true
            }
        ]
    },
    table: {
        sequence: true,
        leftOperation: true,
        showOtpColumnConfig: true,
        rowKey: 'id',
        height: 'calc( 100vh - 220px )', // 样式被穿透了
        columns: [
            {
                label: '工单号',
                align: 'center',
                prop: 'wipEntityName',
                width: 200
            },
            {
                label: '订单单号',
                align: 'center',
                prop: 'orderNo',
                width: 110
            },
            {
                label: '订单生产编码',
                align: 'center',
                prop: 'productOrderNo',
                width: 150
            },
            {
                label: '箱前缀',
                align: 'center',
                prop: 'boxingPrefix',
                width: 150
            },
            {
                label: '产品描述',
                align: 'center',
                prop: 'itemName',
                width: 300
            },
            {
                label: '箱条码',
                align: 'center',
                prop: 'barcode',
                width: 200
            },
            {
                label: '箱物料编码',
                align: 'center',
                prop: 'boxMitemCode',
                width: 150
            },
            {
                label: '标贴类型',
                align: 'center',
                prop: 'boxType',
                width: 100
            },
            {
                label: '总净重',
                align: 'center',
                prop: 'totalNetWeight',
                width: 100
            },
            {
                label: '总毛重',
                align: 'center',
                prop: 'totalGrossWeight',
                width: 100
            },
            {
                label: '箱长',
                align: 'center',
                prop: 'boxLength',
                width: 100
            },
            {
                label: '箱宽',
                align: 'center',
                prop: 'boxWidth',
                width: 100
            },
            {
                label: '箱高',
                align: 'center',
                prop: 'boxHeight',
                width: 100
            },
            {
                label: '包装模式',
                align: 'center',
                prop: 'packMode',
                width: 100
            },
            {
                label: '包装内容',
                align: 'center',
                prop: 'packContent',
                width: 150
            },
            {
                label: '状态',
                align: 'center',
                prop: 'state',
                width: 50
            },
            {
                label: '出货状态',
                align: 'center',
                prop: 'shipStatus',
                width: 200
            },
            {
                label: '虚拟柜号',
                align: 'center',
                prop: 'virtualContainer',
                width: 100
            },
            {
                label: '箱创建时间',
                align: 'center',
                prop: 'datetimeCreated',
                width: 150
            },
            {
                label: '出货通知书',
                align: 'center',
                prop: 'sourceBillNo',
                width: 200
            },
            {
                label: '装柜仓库',
                align: 'center',
                prop: 'shiporgInvName',
                width: 200
            },
            {
                label: '装柜子库',
                align: 'center',
                prop: 'shipOrgName',
                width: 200
            },
            // TODO字段未定义
            {
                label: '实际柜号',
                align: 'center',
                prop: 'actContainerNo',
                width: 200
            },
            // {
            //     label: '外销条码流向',
            //     align: 'center',
            //     prop: 'actContainerNo',
            //     width: 200
            // },
            {
                label: '出货时间',
                align: 'center',
                prop: 'billDate',
                width: 200
            }
        ],
        action: [
            {
                type: 'text',
                label: '明细',
                color: '',
                event: 'detail'
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
        pageNo: 1,
        pageSizes: [10, 20, 30, 50, 100]
    },
    showPage: true
};
